import React from 'react';
import '../../assets/styles/AboutUs.css';
import '../../assets/styles/SectionBand.css';
import '../../assets/styles/AboutPage.css';

import AboutUs0 from './AboutUs_0';
import AboutUs1 from './AboutUs_1';
import StartLando from './StartLando';
import Footer from '../Footer';

const AboutUs = () => {
  return (
    <div className="brand-page-stack about-page">
      <AboutUs0 />
      <AboutUs1 />
      <StartLando />
      <Footer />
    </div>
  );
};

export default AboutUs;
